import React from "react";

//header
import Header from "../../components/partials/dashboard/HeaderStyle/header";

//sidebar
// RightSidebar removed to hide chat section

//sidebar
import Sidebar from "../../components/partials/dashboard/SidebarStyle/sidebar";

//footer
import Footer from "../../components/partials/dashboard/FooterStyle/footer";

//settingoffCanvas
import SettingOffCanvas from "../../components/setting/SettingOffCanvas";
import { Outlet } from "react-router-dom";

// Import authentication check hook
import useAuthCheck from "../../components/hooks/useAuthCheck";

const Default = () => {
  // Check authentication status periodically
  useAuthCheck();
  
  return (
    <>
      <Sidebar />
      {/* <HeaderOne/> */}
      <div className="main-content">
        <div className="position-relative">
        <Header />
        {/* <div id="content-page" className="content-inner"> */}
        {/* <DefaultRouter/> */}
        <Outlet />
        {/* </div> */}

        </div>
      </div>
      {/* RightSidebar removed to hide chat section */}
      <Footer />
      <SettingOffCanvas />
    </>
  );
};

export default Default;
